
<div class="row">
    <div class="col">
        <div class="search-box">
            <input type="text" placeholder="{{searchBarPlacholder}}" (input)="search($event)" [(ngModel)]="searchValue">
            <img src="../../../../assets/images/search-icon-1.svg" alt="search-icon-1" width="24px" height="24px" class="search-1"
            *ngIf="!searchValue || searchValue.length == 0">
            <img src="../../../../assets/images/search-icon-2.svg" alt="search-icon-2" width="24px" height="24px" class="search-2"
            *ngIf="!searchValue || searchValue.length == 0">
            <img src="../../../../assets/images/search-icon-2.svg" alt="search-icon-2" width="24px" height="24px" class="search-3"
            *ngIf="searchValue && searchValue.length > 0">
        </div>
    </div>
    <div class="col-auto" style="width:200px">
        <div class="user-details">
            <div class="row">
                <div class="col-auto p-0 content-center" style="width:40px">
                    <div class="img-circle">
                        <img src="../../../../assets/images/user-icon.svg" alt="user-icon" width="24px" height="24px">
                    </div>
                </div>
                <div class="col ml-auto p-0 pl-8">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 p-0 username">
                                Hello, {{username|titlecase}}
                            </div>
                            <div class="col-12 p-0">
                                <button class="btn-1 btn-no-border" (click)="onLogout()">Logout</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>   